export default "__VITE_ASSET__Eokm6cBp__"